import React from 'react';
import ReactSelect from 'react-select';
import './Select.css';

const Select = ({ 
  options,
  value,
  onChange,
  name,
  placeholder = 'Select an option',
  error,
  required = false,
  size = 'small',
  isSearchable = true,
  isClearable = true,
  isDisabled = false,
  isMulti = false,
}) => {
  // Convert simple value to option object if needed
  const getValue = () => {
    if (!value) return null;
    if (typeof value === 'object') return value;
    const option = options.find(opt => opt.value === value || opt.id === value);
    return option || null;
  };

  const handleChange = (selectedOption) => {
    if (onChange) {
      onChange({ target: { name: name || '', value: selectedOption } });
    }
  };

  return (
    <div className="select-container">
      <ReactSelect
        isMulti={isMulti}
        value={getValue()}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        isSearchable={isSearchable}
        isClearable={isClearable}
        isDisabled={isDisabled}
        className={`react-select-container ${error ? 'has-error' : ''} ${size}`}
        classNamePrefix="react-select"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 })
        }}
      />
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default Select;
